<div class="layout-fluid-constrained layout-align-center">
  @if (isPromoBannerEnabled) {
    <div class="hp-banner">
      <a routerLink="/page/discounts">
        <img src="/assets/images/hp-banner/desktop.png" alt="" class="img-desktop">
        <img src="/assets/images/hp-banner/mobile.png" alt="" class="img-mobile">
      </a>
    </div>
  } @else {
    <div class="hp-promotion">
      <div class="badge"><span>Внимание</span></div>
        <div class="name">Кредити без неустойки, всички разходи включени в ГПР!</div>
        <a routerLink="/page/discounts" class="link">Научи повече</a>
    </div>
  }
</div>
